export const BrandColors = {
  default: 'black',
  secondary: '#637381',
  primary: '',
}
